
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import get from 'lodash/get';
import { NextPage, NextPageContext } from 'next';
import * as prismic from '@prismicio/client';
import { PageProps } from 'types/pages';
import { mapObjectToQueryString } from 'helpers/url';
import { EventsResponse } from 'pages/api/eventsApi.types';
import { fetchEvents } from 'prismic/api/events';
import { getDocumentRelationsFromFile } from 'prismic/getDocumentRelations';
import { LOCALES, LOCALES_MAP, PRISMIC_CUSTOM_TYPES } from 'prismic/config';
import { client, fetchDocuments, fetchSharedData } from 'prismic/helpers/fetchContent';
import TemplateWrapper from 'components/templates/partials/TemplateWrapper';
import PageBackground from 'components/atoms/PageBackground/PageBackground';
import { OverviewEvents } from 'components/organisms/OverviewEvents';
import Header from 'components/organisms/Header/Header';
import { Footer } from 'components/organisms/Footer';
import { formatDateForQuery } from 'helpers/date';
import { mapNextLocaleToISOLanguageCode } from 'helpers/locale.helper';
import { HeaderSpacer } from 'components/atoms/HeaderSpacer';

const { page, header, footer } = PRISMIC_CUSTOM_TYPES;

interface EventsPageProps extends PageProps {
  events: EventsResponse;
}

const EventsOverview: NextPage<EventsPageProps> = ({ header, data, footer, events }) => {
  const { alternate_languages } = data;

  return (
    <TemplateWrapper pageId={data.id} data={data}>
      <PageBackground />
      <Header {...header} alternateLanguages={alternate_languages} />
      <HeaderSpacer />
      <OverviewEvents data={data} events={events} />
      <Footer data={get(footer, 'data.body', [])} />
    </TemplateWrapper>
  );
};

 async function _getServerSideProps(context: NextPageContext) {
  const { domain } = context.query;

  const localePrefix = context.locale;

  const currentDomain =
    (domain && (typeof domain === 'string' ? domain : domain[0])) || 'ballenberg.ch';

  const locale =
    (localePrefix && (typeof localePrefix === 'string' ? localePrefix : localePrefix[0])) ??
    LOCALES.default;
  const lang = LOCALES_MAP[locale];

  const isoLangCode = mapNextLocaleToISOLanguageCode(locale);

  const sharedData = await fetchSharedData(lang);

  const documentRelations = await getDocumentRelationsFromFile();

  // Get page data
  const documents = await fetchDocuments({ pageType: 'events_uebersicht', lang });
  const fetchedContent = documents.length > 0 ? documents[0] : null;

  // Get Header and footer
  const [headerData, footerData] = await Promise.all([
    client.getFirst({
      lang,
      predicates: [
        prismic.predicate.at('document.tags', [currentDomain]),
        prismic.predicate.at('document.type', header),
      ],
    }),
    client.getFirst({
      lang,
      predicates: [
        prismic.predicate.at('document.tags', [currentDomain]),
        prismic.predicate.at('document.type', footer),
      ],
    }),
  ]);

  const fetchedContentHeaderFooter = {
    header: headerData,
    footer: footerData,
    domain: currentDomain,
    type: page,
  };

  // Get Event boxes data
  let eventsData: EventsResponse | undefined;

  try {
    let queryString = '';
    if (context.query) {
      const queryObj = { ...context.query };
      delete queryObj.domain;

      if (!context.query.startDate) {
        queryObj.startDate = formatDateForQuery(new Date());
      }

      queryObj.locale = isoLangCode;
      queryString = mapObjectToQueryString(queryObj);
    }

    const resp = await fetchEvents({ domain: currentDomain, query: queryString });
    eventsData = resp.data;
  } catch (error) {
    console.error('[Events] fetch events error', error);
  }

  // Return Error page if no content
  const is404 = !fetchedContent;

  if (is404) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      data: { ...fetchedContent },
      ...fetchedContentHeaderFooter,
      sharedData,
      documentRelations,
      events: eventsData,
    } as EventsPageProps,
  };
}

export default EventsOverview;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/[domain]/events/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  